export default function DocsProtocolSynopsis(){
  return(
    <div>
      Synopsis coming soon! 
    </div>
  );
}